import { render, staticRenderFns } from "./SfProductCardHorizontal.vue?vue&type=template&id=9f61e01a&"
import script from "./SfProductCardHorizontal.vue?vue&type=script&lang=js&"
export * from "./SfProductCardHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./SfProductCardHorizontal.vue?vue&type=style&index=0&id=9f61e01a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports